import { getApprovalFlow as apiGetApprovalFlow, getApprovalFlows } from "api/approvalFlow";
import constate from "constate";
import { useFetchedState } from "hooks/useFetchedState";
import { useOpenGlobalErrorModal } from "hooks/useGlobalError";
import { type Map } from "immutable";
import { type ApprovalFlowModel } from "models/ApprovalFlowModel";
import { useCallback } from "react";

const useApprovalFlows = () => {
  const {
    data: approvalFlows,
    loadData: loadApprovalFlows,
    setData: setApprovalFlows,
  } = useFetchedState(getApprovalFlows);

  const openGlobalErrorModal = useOpenGlobalErrorModal();

  const getApprovalFlow = useCallback(
    async (id: string) => {
      try {
        return await apiGetApprovalFlow(id);
      } catch (error) {
        openGlobalErrorModal(error as Error);
        return null;
      }
    },
    [openGlobalErrorModal],
  );

  const addApprovalFlows = useCallback(
    (approvalFlowsToAdd: Map<string, ApprovalFlowModel>) => {
      setApprovalFlows((approvalFlows) => (approvalFlows ? approvalFlows.merge(approvalFlowsToAdd) : approvalFlowsToAdd));
    },
    [setApprovalFlows],
  );

  return {
    actions: { addApprovalFlows, getApprovalFlow, loadApprovalFlows },
    state: { approvalFlows },
  };
};

export const [ApprovalFlowsProvider, useApprovalFlowsContext] = constate(useApprovalFlows);
